
import { GET_REPAIR_FAILURE, GET_REPAIR_REQUEST, GET_REPAIR_SUCCESS, GET_RETURNS_FAILURE, GET_RETURNS_REQUEST, GET_RETURNS_SUCCESS } from "./returnsTypes";

const initialState = {
  loading: false,
  return: [],
  error: "",
};

const getReturnsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_RETURNS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RETURNS_SUCCESS:
      return {
        loading: false,
        return: action.payload,
        error: "",
      };
    case GET_RETURNS_FAILURE:
      return {
        loading: false,
        return: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};
const initialStateD = {
  loading: false,
  return: [],
  error: "",
};

const getRepairCenterReducer = (state = initialStateD, action) => {
  switch (action.type) {
    case GET_REPAIR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REPAIR_SUCCESS:
      return {
        loading: false,
        return: action.payload,
        error: "",
      };
    case GET_REPAIR_FAILURE:
      return {
        loading: false,
        return: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

export { getReturnsReducer,
  getRepairCenterReducer
    //  getDocumentTypeWithPaginationReducer 
    };
